import { ReactNode } from 'react';
import styles from './HighlightBox.module.css';

interface HighlightBoxProps {
  title: string;
  children: ReactNode;
}

export const HighlightBox = ({ title, children }: HighlightBoxProps) => {
  return (
    <div className={styles.highlightBox}>
      <h4>{title}</h4>
      {children}
    </div>
  );
};
